export default {
  banOperate: true,
  props: [
    {
      attr: 'name',
      name: '文档名称'
    },
    {
      attr: 'parse',
      name: '课堂阶段',
      slot: 'parse'
    }
  ]
}
